/**
 * Componente EmptyState - ConfereAI
 *
 * Estado vazio padronizado quando não há dados.
 * Baseado no layout da página de Veículos.
 */

import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  actionText?: string;
  onAction?: () => void;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionText,
  onAction,
  className = '',
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <i className={`${icon} empty-state-icon`}></i>
      <h3>{title}</h3>
      <p>{description}</p>
      {actionText && onAction && (
        <button className="btn btn-primary" onClick={onAction}>
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
